<!-- Tablet view hamburg -->
<div class="mobile-menu-btn" (click)="toggleReportMenu()"
     [@moveButton]="isSideMenuOpen ? 'open' : 'closed'"
     [ngClass]="{'opened-button': isSideMenuOpen}">
  @if (isSideMenuOpen){
    <svg-icon name="blue-caret-right"></svg-icon>
  }@else{
    <svg-icon name="caret-left"></svg-icon>
  }
</div>

<!-- Tablet + Mobile view menu -->
<div class="menu-container">
  <!-- Overlay when menu is open -->
  <div class="overlay" *ngIf="isSideMenuOpen" (click)="toggleReportMenu()"></div>

  <!-- Sidebar Menu -->
  <div class="side-menu" [@slideInOut]="isSideMenuOpen ? 'open' : 'closed'">
    <report-side-menu [stageNo]="stageNo" *ngIf="stageNo > 0 && stageNo < 38"
                      (pageChanged)="toggleReportMenu()"></report-side-menu>
  </div>
</div>

<div class="row footer-parent">
  <div class="col-lg-9 col-md-8 pl-48 position-relative" #reportPart id="reportPart" [ngClass]="{'report__part custom__scroll__secondary__blue' : stageNo!=pageNumberEnum.ADJUSTMENTS && stageNo!=pageNumberEnum.WEIGHTING_TABLE && stageNo!=pageNumberEnum.ASSETS_LIABILITIES}">

    <div class="row justify-content-md-center">

      <ng-container *ngIf="(currentReport?.STATE === reportStateEnum.CREATED || currentReport?.STATE === reportStateEnum.LOCKED) && currentReport?.LATEST?.COMPLETION === 100 && stageNo != pageNumberEnum.CONCLUSION && currentReport?.CREATED_BY?.ID == userService.getUserId()">
        <div class="col-md-12">
          <div class="status" *ngIf="showNotification">
            <svg-icon name="Credit_Card" svgClass="mr-12"></svg-icon>
            <div class="w-100">
              <ng-container *ngIf="currentReport?.STATE === reportStateEnum.CREATED">
                Report is ready. Pay for the report to download it.
              </ng-container>
              <ng-container *ngIf="currentReport?.STATE === reportStateEnum.LOCKED">
                The time to edit your report has expired and your report is currently locked for editing. Pay to unlock the report for further editing.
              </ng-container>
              Please <span class="buy" (click)="gotoConclusion()">buy the report</span>.
            </div>
            <svg-icon name="Close_Status" (click)="closeNotification()"></svg-icon>

          </div>
        </div>
      </ng-container>

      <div class="col-md-12 sticky__header" *ngIf="firstTitle">
        <report-header [parentTitle]="firstTitle" [childTitle]="secondTitle" [infoTooltip]="infoTooltip"></report-header>
      </div>

      <div
        [ngClass]="(stageNo==pageNumberEnum.INCOME || stageNo==pageNumberEnum.FUTURE_PROJECTIONS || stageNo==pageNumberEnum.PROJECTION_TABLE || stageNo==pageNumberEnum.ADJUSTMENTS || stageNo==pageNumberEnum.WEIGHTING_TABLE || stageNo==pageNumberEnum.ASSETS_LIABILITIES || stageNo==pageNumberEnum.CONCLUSION || stageNo==50) ? 'col-md-12' : 'col-lg-10 col-md-12'">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
  <div class="col-lg-3 col-md-4 desktop-menu" *ngIf="stageNo <= 38">
    <report-side-menu [stageNo]="stageNo" *ngIf="stageNo > 0 && stageNo < 38"></report-side-menu>
  </div>
</div>
